import React from 'react';
import { Button } from 'ui';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import { routes, SCREEN_SIZES } from 'constants/config';
import useWindowSize from 'hooks/useWindowSize';
import {
  IllustrationCannotViewDeleted,
  Theme,
  seismicTheme,
} from '@seismic/mantle';
import useColors from 'ui/hooks/useColors';
import classNames from 'classnames';

const EventNotFoundGraphic = ({ isEditor, isLearner }) => {
  const { colorPrimary } = useColors();
  const { width } = useWindowSize();
  const isMobile = width < SCREEN_SIZES.SM;
  const isTablet = width >= SCREEN_SIZES.SM && width < SCREEN_SIZES.MD;
  let svgSize;

  if (isMobile) {
    svgSize = 'sm';
  } else if (isTablet) {
    svgSize = 'md';
  } else {
    svgSize = 'lg';
  }

  return (
    <div className="Event-NotFound EditorElement-body d-f fd-c jc-c p-50">
      <Theme
        theme={seismicTheme({
          useGlobal: true,
          customization: {
            colors: {
              primary: colorPrimary,
            },
          },
        })}
        className="d-f jc-c"
      >
        <IllustrationCannotViewDeleted size={svgSize} />
      </Theme>
      <div className="Event-NotFound--text d-f fd-c ai-c">
        <Text variant={TEXT_VARIANTS.TITLE_BOLD} className="ta-c">
          {isEditor && t('lessons.editor.event.not_found')}
          {isLearner &&
            t('in_person_training.errors.event_no_longer_available')}
          {!isEditor && !isLearner && t('learning.lessons.event.not_found')}
        </Text>
        <Text
          variant={TEXT_VARIANTS.BODY_LIGHT}
          className={classNames('ta-c', { 'mt-12': isLearner })}
        >
          {isEditor && t('lessons.editor.event.not_found_desc')}
          {isLearner &&
            t('in_person_training.errors.event_no_longer_available_desc')}
          {!isEditor &&
            !isLearner &&
            t('learning.lessons.event.not_found_desc')}
        </Text>
        {isLearner && (
          <Button
            type="button"
            className="mt-24 w-fc"
            onClick={() => {
              window.location = routes.IN_PERSON_TRAINING.EVENTS_DASHBOARD;
            }}
          >
            {t('in_person_training.events.go_to_my_training_events')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default EventNotFoundGraphic;
